function toggleGiftCardBalance() {

}